interface StatusLabelProps {
  variant: string
  label: string
}

export default StatusLabelProps
export const getNetworkStatusVariant = (status: string) => {
  const variants: any = {
    connected: "ok",
    pending: "alert",
    disconnected: "error"
  }

  return variants[status]
}

export const startWithUpperCase = (value: string) => {
  if (!value) {
    return value
  }

  return value?.length > 0 ? value?.replace(/^./, value[0].toUpperCase()) : ""
}
export const getCompanyIdentifications = (data: any) => {
  const idents: string[] = data?.identifications?.map((ident: any) => {
    if (!ident?.value) {
      return ""
    }

    return `${ident?.type?.toUpperCase()}#: ${ident?.value || "-"}`
  }) || ["-"]

  // Don't return null identifications
  return idents.filter((i: string) => i !== "").join(" | ")
}
